import {BaseStore} from "./base.store";
import {RootStore} from "./index";
import {makeObservable, observable, runInAction} from "mobx";
import useCaseService from "../../services/use-case.service";

export class AdminStore extends BaseStore {
    public savedPortalUrl: string = '/';
    public fullApnsList = [];

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            savedPortalUrl: observable,
            fullApnsList: observable
        });
    }

    public setSavedPortalUrl(savedPortalUrl: string) {
        this.savedPortalUrl = savedPortalUrl;
    }

    get getSavedPortalUrl(): string {
        return this.savedPortalUrl;
    }

    public async load() {
        try {
            this.setIsLoading(true);
            const fullApnsList = await useCaseService.getFullApnsList();
            runInAction(() => {
                this.fullApnsList = [...fullApnsList];
                this.setIsLoading(false);
            })
        } catch (e) {
            runInAction(() => {
                this.setIsLoading(false);
            })
        }
    }
}